<div class="col-sm-12 detail" *ngIf="!isEmpty" style="height: 100%" (click)="common.outSide($event)">
    <div class="header col-sm-12">
        <!-- <div class="col-sm-6">
            <h2 *ngIf="!isHisto" style="width: 95%;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;"> CAP du client : {{detail.nomClient || ''}} </h2>
            <h2 *ngIf="isHisto"> Historique des CAP </h2>
            <div class="text-underline historique" style="padding-right: 0px" (click)="showHisto()">
                <span *ngIf="!isHisto"> Afficher l'historique </span>
                <span *ngIf="isHisto"> Afficher la liste </span>
            </div>
        </div>
        <div class="col-sm-6 text-right">
            <button class="btn-header uppercase" id="print" (click)="getFormatperso()"> Imprimer la sélection </button>
            <button class="btn-header uppercase" id="xls" (click)="exportXLS()"> Extraire Excel </button>
            <button class="btn-header uppercase" id="close" (click)="hide()"> Fermer </button>
        </div> -->

        <div class="col-sm-12 p-0">
            <div class="col-sm-6">
                <h2 *ngIf="!isHisto" style="width: 95%;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;">
                    CAP du client </h2>
                <h2 *ngIf="isHisto"> Historique des CAP </h2>

            </div>
            <div class="col-sm-6 text-right">
                <button class="btn-header uppercase" id="print" (click)="getFormatperso()"> Imprimer la sélection </button>
                <button class="btn-header uppercase" id="xls" (click)="exportXLS()"> Extraire Excel </button>
                <button class="btn-header uppercase" id="close" (click)="hide()"> Fermer </button>
            </div>
        </div>
        <div class="col-sm-12">
            <h2 *ngIf="!isHisto" class="col-sm-12 p-0"
                style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;"> {{detail.nomClient || ''}} </h2>
                <div class="text-underline historique" style="padding-right: 0px" (click)="showHisto()">
                    <span *ngIf="!isHisto"> Afficher l'historique </span>
                    <span *ngIf="isHisto"> Afficher la liste </span>
                </div>
        </div>
    </div>

    <div class="col-sm-12 ligneBon liste"  [ngStyle]="{'height': !isHisto ? 'calc(100% - 171px)' : 'calc(100% - 146px)'}">
        <ngx-datatable *ngIf="renderTable" style="height: 110%" class="material" [rows]="listCAP || []" [columnMode]="'force'"
            [headerHeight]="35" [footerHeight]="0" [rowHeight]="30" [selectionType]="'checkbox'" [messages]="{emptyMessage: 'Pas de lignes à afficher'}"
            [loadingIndicator]="loadingIndicator" [selected]="selected">

            <ngx-datatable-column prop="libelle">
                <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                    let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                        <span class="uppercase"> CAP </span>
                        <div class=" col-sm-1 pull-right">
                          <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                          <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                      </div>
                    </div>
                </ng-template>
                <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{value}}
                </ng-template>
            </ngx-datatable-column>


            <ngx-datatable-column prop="libelleArticle">
                <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                    let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                        <span class="uppercase"> Article </span>
                        <div class=" col-sm-1 pull-right">
                          <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                          <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                      </div>
                    </div>
                </ng-template>
                <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{value}}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column  prop="dateFilter">
                <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                    let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                        <span class="uppercase"> Date Emission </span>

                        <div class=" col-sm-1 pull-right">
                          <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                          <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                        </div>

                    </div>
                </ng-template>
                <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                  {{row.dateEmission }}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column prop="chantier.numChantier">
                <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                    let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                        <span class="uppercase"> Chantier </span>

                        <div class=" col-sm-1 pull-right">
                          <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                          <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                        </div>

                    </div>
                </ng-template>
                <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{ value || 'Tous' }}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column prop="typeContenant.famille.libelle">
                <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                    let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                        <span class="uppercase"> Type Contenant </span>

                        <div class=" col-sm-1 pull-right">
                          <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                          <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                        </div>
                    </div>
                </ng-template>
                <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{ value || 'Tous' }}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column prop="typeContenant.cubage.cubage">
                <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                    let-sort="sortFn">
                    <div class="tableheader" (click)="sort()">
                        <span class="uppercase"> Cubage </span>

                        <div class=" col-sm-1 pull-right">
                          <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                          <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                        </div>

                    </div>
                </ng-template>
                <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{ value }}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [width]="70" [sortable]="false" [canAutoResize]="false"
                [draggable]="false" [resizeable]="false">
                <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn">
                    <input type="checkbox" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked"
                        [(ngModel)]="checkedall" (change)="checkedAll($event)" [ngClass]="{'regular-checkbox-checked': checkedall}" />
                </ng-template>
                <ng-template ngx-datatable-cell-template let-row="row">
                    <input type="checkbox" id="checkbox-1-1" class="regular-checkbox" [(ngModel)]="row.isChecked"
                        (change)="checkedRow(row)" [ngClass]="{'regular-checkbox-checked': row.isChecked}" />
                </ng-template>
            </ngx-datatable-column>
        </ngx-datatable>
    </div>
    <div class="addLigne col-sm-12 uppercase">
        <div class="col-sm-7 text-left">
            <!--button class="btn-add" id="addLigne" (click)="selectedRow = {}; common.openModal(modalService, formEdit)">
              <i class="fa fa-plus"></i>
            </button>
            <span (click)="selectedRow = {}; common.openModal(modalService, formEdit)">Ajouter une ligne</span-->
            <!-- <button class="btn-add" id="addLigne" (click)="selectedRow = {}">
                <i class="fa fa-plus"></i>
            </button>
            <span (click)="selectedRow = {};">Ajouter une ligne </span> -->

        </div>
        <label class="text-left uppercase text-underline historique col-sm-5"></label>
    </div>
</div>

<app-empty-detail-fact *ngIf="isEmpty" id="empty"></app-empty-detail-fact>


<ng-template #msg>
    <div class="modal-body" style="height: auto">
        <div>
            <div class="col-sm-12">
                <label class="cofirmemsg" [innerHTML]="error"> </label>
            </div>
        </div>
        <div class="text-right" style="margin-top: 15px;">
            <button type="button" class=" btn-close btn-valider" (click)="error = ''; common.closeModal()"> Fermer
            </button>
        </div>
    </div>
</ng-template>

<ng-template #format>
    <div class="modal-header">
        <h4 class="modal-title pull-left">Choix du format </h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" style="height: auto">
        <div>
            <ul class="list-group listeformat" *ngIf="formatPerso.length">
                <li class="list-group-item" *ngFor="let item of formatPerso" (click)="formatprs = item" [ngClass]="{'formatselected': formatprs.id === item.id}">
                    {{ item.libelleObjetEntite }}
                </li>
            </ul>

            <span *ngIf="!formatPerso.length"> Aucun format disponible. Veuillez en définir au moins un </span>

        </div>
        <div class="text-right" style="margin-top: 15px;">
            <button type="button" class=" btn-close btn-valider" *ngIf="!formatPerso.length" (click)="common.closeModal()">
                Fermer </button>
            <button type="button" class=" btn-close btn-valider" *ngIf="formatPerso.length" (click)="isImprimepese ? imprimerPese() : printSelected()">
                Valider </button>
            <button type="button" class=" btn-close" (click)="common.closeModal()"> Annuler </button>
        </div>
    </div>
</ng-template>